export default __webpack_public_path__ + "static/smartphone-2-8a942af43926b582941ebaaa58ed2ece.webp";